import { render } from "./Roulette13.vue?vue&type=template&id=a189de88&scoped=true"
import script from "./Roulette13.vue?vue&type=script&lang=js"
export * from "./Roulette13.vue?vue&type=script&lang=js"

import "./Roulette13.vue?vue&type=style&index=0&id=a189de88&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a189de88"]])

export default __exports__